import { createSelector } from "@reduxjs/toolkit";

// Select the entire auth state
export const selectAuthState = (state) => state.auth;

// Select authentication status (whether the user is logged in)
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;

// Select the authentication token
export const selectAuthToken = (state) => state.auth.token;

// Select authentication loading state
export const selectAuthLoading = createSelector(
  selectAuthState,
  (auth) => auth.loading
);

// Select authentication error messages (if any)
export const selectAuthError = createSelector(
  selectAuthState,
  (auth) => auth.error
);
